<!-- eslint-disable vue/no-mutating-props -->
<!--表格上列配置界面-->
<template>
  <el-input
    v-model="filterWord"
    :prefix-icon="Search"
    placeholder="输入字段名(或拼音)搜索"
    clearable
    class="filter-kw"
  />
  <div class="drawer-tips">
    <el-icon><Warning /></el-icon>
    <span>可对列表中数据列进行隐藏、拖拽排序</span>
  </div>

  <el-scrollbar height="100%">
    <draggable :list="columns" item-key="name" @change="onOrderChange">
      <template #item="{ element }">
        <div
          v-if="visibles[element.name] != 'deleted'"
          v-show="pinyinMatch(element.title, filterWord)"
          class="col-item"
        >
          <el-checkbox
            v-model="visibles[element.name]"
            @change="setColumnVisible(element.name)"
          >
            {{ element.title }}
          </el-checkbox>
        </div>
      </template>
    </draggable>
  </el-scrollbar>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { Warning, Search } from '@element-plus/icons-vue';
import Draggable from 'vuedraggable';
import { cloneDeep } from 'lodash-es';
import { pinyinMatch } from '../../core/CommonInternal';

const props = defineProps<{
  tableCtx: {
    visibles: Record<string, boolean | 'deleted'>;
    columns: { name: string; title: string }[];
    showColumn: (name: string, visible: boolean, save: boolean) => void;
    moveColumn: (name: string, index: number) => void;
    restore: () => void;
  };
}>();

const columns = ref(cloneDeep(props.tableCtx.columns));
// eslint-disable-next-line vue/no-setup-props-destructure
const visibles = props.tableCtx.visibles;

function setColumnVisible(name: string) {
  const visible = visibles[name];
  if (visible == 'deleted') return;

  const showColumn = props.tableCtx.showColumn;
  showColumn?.(name, visible, true);
}

// 移动元素
function onOrderChange(evt: any) {
  const moveColumn = props.tableCtx.moveColumn;
  moveColumn?.(evt.moved.element.name, evt.moved.newIndex);
}

const filterWord = ref('');
</script>

<style lang="scss" scoped>
.filter-kw {
  padding: var(--tabbed-drawer-padding);
  padding-top: 12px;
  padding-bottom: 0px;

  // fix erp2
  :deep(.el-input__wrapper) {
    box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color))
      inset;
  }
}

.col-item {
  box-sizing: border-box;
  height: 36px;
  padding: 0 var(--tabbed-drawer-padding);

  &:hover {
    background-color: #f3f4f6;
  }
}

.drawer-tips {
  padding: 16px;
  font-size: 12px;
  font-weight: 500;
  color: #8f959e;

  .el-icon {
    top: 2px;
    margin-right: 4px;
    transform: rotate(180deg);
  }
}
</style>
